import { CSSProperties } from "react";
import { Error24 } from "@weave-design/icons";
import { ModelTranslationStatus } from "../../../../../responses/linkedModel";
import { ProcessingProgressBar } from "../../../../processing-pane/processingProgressBar";
import { LinkedModelView } from "../../../eventBus/linkedModelsEventPayloads";
import "./linkedModelCard.css";

const imgWidth = 98;
const progressBarStyle: CSSProperties = { width: imgWidth - 16 * 2, padding: 0 };

type Props = {
    model: LinkedModelView;
    status: ModelTranslationStatus;
    translationProgressPercentage: number;
};

export const LinkedModelThumbnail = ({ model, status, translationProgressPercentage }: Props) => {
    if (status === ModelTranslationStatus.Ready) {
        return (
            <img
                src={`/api/linked-models/${model.id}/thumbnail`}
                width={imgWidth}
                height={imgWidth}
                alt="Model preview"
            />
        );
    }

    if (status === ModelTranslationStatus.Created) {
        return (
            <div style={{ padding: 16 }}>
                <ProcessingProgressBar
                    style={progressBarStyle}
                    tooltip={{ message: `${translationProgressPercentage}%`, style: { top: 10 } }}
                />
            </div>
        );
    }

    if (status === ModelTranslationStatus.Failed) {
        return (
            <div style={{ padding: 33 }}>
                <Error24 className="errorIcon" />
            </div>
        );
    }

    return null;
};
